// extracted by mini-css-extract-plugin
export var dropdownContainer = "_5s-5";
export var imageContainer = "_5s-4";
export var metricsGrid = "_5s-2";
export var productDetailContainer = "_5s-1";
export var productListContainer = "_5s-0";
export var subscriberTableContainer = "_5s-3";